import { gql } from "@apollo/client";

export const GET_TENANT = gql`
  query GetTenant($tenantId: String!) {
    getTenant(tenantId: $tenantId) {
      message
      response
    }
  }
`;